export default [
  {
    path: "/activity-logs",
    name: "Activity Logs",
    component: () => import("../views/activity-log/ActivityLogIndex.vue"),
    meta: {
      layout: "default",
      role: ["superadmin", "supervisor"],
      public: false,
    },
  },
];
